<div class="h-100" (window:resize)="onResize($event)">
    <div class="sopview-top">
        <div class="sop-close" *ngIf=isDesktop>
            <button type="button" class="close" (click)="modalRef.hide()">
                <!-- <span aria-hidden="true">&times;</span> -->
            </button>
        </div>
        <div class="col-12 p-0 d-flex justify-content-between align-items-start">
            <div>
                <h5 class="sop-title modal-title w-100 sticky observation-title">{{ 'E_LEARNING.RESULT' | translate }}:
                    {{sopName | translate | labelSanitizer}}</h5>
                <p class="sop-desc text-left m-0 observation-description">{{ sopDescription |translate |
                    labelSanitizer}}
                </p>
            </div>
            <div class="px-5">
                <span class="observation-info">{{formdata.ward.wardName | translate | labelSanitizer}}</span>
                <span class="specs-center observation-info">{{formdata.department.departmentName | translate |
                    labelSanitizer}}</span>
                <span class="observation-info">{{formdata.category.categoryName | translate | labelSanitizer}}</span>
                <span class="specs-sub observation-info"
                    *ngIf="showProfessionalSubcategory">{{formdata.subCategory.subCategoryName | translate |
                    labelSanitizer}}</span>
                <div *ngIf="swappedSteps" class="swapped-box mt-1"><p class="m-0 swapped-text">{{ 'SOP_OBSERVATION.SWAPPED_STEPS' | translate }}</p></div>
            </div>
        </div>
        
    </div>
    <div class="sopview-body modal-body ui-dialog-fixed">
        <div class="image-container-fixedsize justify-content-md-start justify-content-center">
            <div class="d-flex justify-content-center image-div-scroll">
                <div class="row m-0 col-12 card-holder" #cardHolder>
                    <ng-container *ngFor="let step of sopStep; let i = index">
                        <div class="card card-strip" #card *ngIf="step.stepType"
                            [class.mutli-step-start-image]='step.stepType'>
                            <div *ngIf="i == 0" class="start-image d-flex align-items-center"></div>
                            <div *ngIf="i == sopStepLength" class="start-image-end d-flex align-items-center">
                            </div>
                            <div class="card-task">
                                <div class="card-task-media" [ngClass]="(!showStepList[i])?'opacity':''">
                                    <!-- <div class="multi-step-image-overlay"></div> -->
                                    <img class="card-img-top multi-step-image-overlay"
                                        [ngClass]="(step.stepImage)?'svg':'no-image'"
                                        [src]="(step.stepImage)?layoutService.serverUrl+step.stepImage:'assets/img/fallback-img.png'"
                                        (error)="errImg($event)" alt="SOP">
                                    <span class="multiImage"></span>
                                </div>
                                <div class="card-task-content d-flex align-items-center"
                                    [class.handDisinfy]="step.stepCards[0].hygieneRelevantStep">
                                    <p class="card-task-desc card-text">
                                        {{step.stepName | translate | labelSanitizer}}</p>
                                </div>

                            </div>
                        </div>
                        <ng-template [ngIf]="!step.stepType || showStepList[i]">
                            <div class="card card-strip" #card *ngFor="let stepCards of step.stepCards; let j = index"
                                [class.mutli-step-sub-cards]='step.stepType'>
                                <div *ngIf="i == 0 && !step.stepType" class="start-image d-flex align-items-center">
                                </div>
                                <div *ngIf="i == sopStepLength && !step.stepType"
                                    class="start-image-end d-flex align-items-center">
                                </div>
                                <div class="card-task" (click)="selectStep(i,j,step.stepType)"
                                    [ngClass]="(!seletedSteps[i] || !seletedSteps[i][j])?'':'selected'">
                                    <div class="d-flex justify-content-center icon-middle"
                                        *ngIf="stepCards.hygieneRelevantStep && ( !seletedSteps[i] || ( seletedSteps[i] && !seletedSteps[i][j])) ">
                                        <img src="assets/ph-bhp-sopobservation/SOP-Images/icon-thumb-down.svg" />
                                    </div>
                                    <div class="d-flex justify-content-center icon-middle"
                                        *ngIf="stepCards.hygieneRelevantStep &&  ( ( seletedSteps[i] && seletedSteps[i][j]))">
                                        <img src="assets/ph-bhp-sopobservation/SOP-Images/icon-thumb-up.svg" />
                                    </div>
                                    <div class="card-task-media" [ngClass]="
                                        (
                                            (!seletedSteps[i] || !seletedSteps[i][j]) || 
                                            (
                                                (stepCards.hygieneRelevantStep && (!seletedSteps[i] || ( seletedSteps[i] && !seletedSteps[i][j]))) || 
                                                (stepCards.hygieneRelevantStep && ((seletedSteps[i] && seletedSteps[i][j])))
                                            )
                                        ) ? 'opacity' : ''">
                                        <img class="card-img-top" [ngClass]="(stepCards.stepImage)?'svg':'no-image'"
                                            [src]="(stepCards.stepImage)?layoutService.serverUrl+stepCards.stepImage:'assets/img/fallback-img.png'"
                                            (error)="errImg($event)" alt="SOP">
                                    </div>
                                    <div class="card-task-content d-flex justify-content-between step-card align-items-start"
                                        [class.handDisinfy]="stepCards.hygieneRelevantStep">
                                        <p class="card-task-desc card-text">
                                            {{stepCards.stepTittle | translate | labelSanitizer}}</p>
                                        <div class="icons-div">
                                            <span *ngIf="seletedSteps[i] && seletedSteps[i][j]"
                                            [ngClass]="seletedSteps[i][j].swapped ? 'stepbg-swapped' : 'stepbg'">
                                            {{ seletedSteps[i][j]?.stepOrder }}</span>
                                            <span class="noSterlity"
                                                *ngIf="seletedSteps[i] && seletedSteps[i][j] && seletedSteps[i][j].noSterility"></span>
                                        </div>

                                    </div>

                                    <!-- <span class="step-count">{{(seletedSteps[i] && seletedSteps[i][j])?seletedSteps[i][j].stepOrder:''}}</span> -->
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>

            </div>
        </div>
        <div class="show-comments px-4 w-100 d-flex mt-4 justify-content-end">
        <a class="" (click)="openComment()">{{'SOP_OBSERVATION.SHOW_COMMENTS' |
            translate}}</a><mat-icon>chevron_right</mat-icon>
        </div>
    </div>
    
</div>

<app-ph-bhp-observe-protocol-comments #observeComments [observationId]="observationId" [comments]="comments"
    [isCollapsed]="isCollapsed" [isEdit]="false" [isOverviewIndividual]="isOverviewIndividual"
    (childData)="onchildData($event)"></app-ph-bhp-observe-protocol-comments>